import * as React from 'react';
import AppContainer from './AppContainer';
import {CONTENT_TYPE} from '../../Config/appConfig';

class NormalUsersContainer extends React.Component <{}, {}> {
    public render() {
        return (
            <AppContainer content={CONTENT_TYPE.NORMAL_USERS}/>
        );
    }
}

export default NormalUsersContainer;



// WEBPACK FOOTER //
// ./src/Components/Containers/NormalUsersContainer.tsx